import axios from "axios"
import useSWR from "swr"
import {API_PROJECTS} from "../constants/apiUrls"
import currentAuthSession from "../aws/cognito/currentAuthSession"

export default function useProjectLexicon(accessToken, projectId, setSessionAction) {

    const fetcher = async (url) => {
        try {
            const response = await axios.get(url, {headers: {Authorization: `Bearer ${accessToken}`}})
            for (let lexicon of response.data) {
                if (lexicon.type === "project") {
                    return lexicon
                }
            }
        } catch (error) {
            if (error.response?.status === 401) {
                try {
                    await currentAuthSession()
                    .then(async (response) => {
                        setSessionAction({type: "REFRESH_COGNITO_TOKEN", payload: {idToken: response.idToken.toString()}})
                        const newToken = response.idToken.toString()
                        const retryRes = await axios.get(url, {headers: {Authorization: `Bearer ${newToken}`}})
                        return retryRes.data
                    })
                } catch (refreshError) {
                    throw refreshError
                }
            }
            throw error
        }
    }

    const {data, mutate, error} = useSWR(`${API_PROJECTS}/${projectId}/lexicons`, fetcher)

    return {
        projectLexicon: data,
        mutateProjectLexicon: mutate,
        isLoadingProjectLexicon: !error && !data,
        isErrorProjectLexicon: error
    }
}